/**
 * Ness Frame Character 주문내역 Hook (Shared)
 */
import { compact } from '@fxts/core';
import { bpOptionUtil } from '@modules/BpOption/S/Function/bp-option.util';
import { PriceS } from '@modules/Price/S/Function/module/PriceS';
import { MShopAppUpItemConstantS } from '@modules/MShop/App/UpItem/S/Constant/module/MShopAppUpItemConstantS';
import {
  calculateRetailPrice,
  NessAssocSelectedOptionGroup,
  NessFrameDetails,
  NessFrameProduct,
} from './constant';

/**
 * 주문내역용 옵션 정보 생성
 */
export function makeOptionInfosForNessFrameBpWithOrderHistory(
  selected_option_group: NessAssocSelectedOptionGroup,
  up_c_s_id: number,
  profit: number,
) {
  const bp_options = selected_option_group._.bp_options;
  const details = selected_option_group.details as NessFrameDetails;

  const frame_option = bpOptionUtil.findAssocBpOptionByDevName(bp_options, 'NESS_FRAME');
  const character_option = bpOptionUtil.findAssocBpOptionByDevName(bp_options, 'NESS_CHARACTERS');
  if (!frame_option || !character_option) return;

  const has_characters = details?.value?.frame_characters;
  const character_names = has_characters?.map(({ gc_name }) => gc_name).join(', ');
  const character_quantity = has_characters?.length ?? 0;
  const frame_price = calculateRetailPrice(frame_option, character_option).frame_bp_option_price;
  const frame_quantity = 1;
  const character_total_price = calculateRetailPrice(
    frame_option,
    character_option,
  ).character_bp_option_price;
  const character_price = character_total_price / character_quantity;

  const frame_option_info =
    frame_option.dev_name === NessFrameProduct.BP_OPTIONS.NESS_FRAME_SELECTED
      ? {
          up_c_s_id,
          name: NessFrameProduct.frame_option.group_name,
          quantity: 1,
          discounted_price: frame_price,
          price: frame_price,
          total_price: PriceS.pricify_by(frame_price * frame_quantity, _en),
          status: MShopAppUpItemConstantS.N_OPTION_INFO_STATUS.NORMAL,
        }
      : null;

  const character_option_info = character_names
    ? {
        up_c_s_id,
        name: NessFrameProduct.character_option.group_name,
        option_description: character_names,
        quantity: character_quantity,
        discounted_price: character_price,
        price: character_price,
        total_price: PriceS.pricify_by(character_price * character_quantity, _en),
        status: MShopAppUpItemConstantS.N_OPTION_INFO_STATUS.NORMAL,
      }
    : null;

  const result = compact([frame_option_info, character_option_info]);
  return [...result];
}
